// Generated by scripts/build-ui-icons.mjs.
export { Tag as default } from "../ui/glyphs-7";
